import React from "react";
import {
  TrendingUp,
  TrendingDown,
  TrendingFlat
} from "@material-ui/icons";

const COLORS = {
  up: "#2e7d32",
  down: "#c62828",
  flat: "#757575"
};

const RevenueTrendIcon = ({ percent, className }) => {
  if (percent === null) {
    return (
      <TrendingFlat
        className={className}
        style={{ color: COLORS.flat }}
      />
    );
  }

  if (percent > 0) {
    return (
      <TrendingUp
        className={className}
        style={{ color: COLORS.up }}
      />
    );
  }

  if (percent < 0) {
    return (
      <TrendingDown
        className={className}
        style={{ color: COLORS.down }}
      />
    );
  }

  return (
    <TrendingFlat
      className={className}
      style={{ color: COLORS.flat }}
    />
  );
};

export default RevenueTrendIcon;